// Permission matrix: per-permission UI visibility config, sourced from Utils/Permissions/*,
// plus component name constants and role definitions.

import {
  DINAMIC_TABS_INTERVENTII_DETAILING,
  ROUTER_INTERVENTII_DETAILING,
  VEHICLE_OPTIONS_INTERVENTII_DETAILING,
  VEHICLE_TABLE_INTERVENTII_DETAILING,
} from "../Utils/Permissions/vehicleDetailings";
import {
  DINAMIC_TABS_INTERVENTII_SERVICE,
  ROUTER_INTERVENTII_SERVICE,
  VEHICLE_OPTIONS_INTERVENTII_SERVICE,
} from "../Utils/Permissions/vehicleServices";
import {
  DINAMIC_TABS_INTERVENTII_VOPSITORIE,
  VEHICLE_OPTIONS_INTERVENTII_VOPSITORIE,
  ROUTER_INTERVENTII_VOPSITORIE,
} from "../Utils/Permissions/vehiclePaintings";
import {
  DINAMIC_TABS_COSTURI_ADITIONALE,
  MAIN_TABLE_COSTURI_ADITIONALE,
  ROUTER_COSTURI_ADITIONALE,
  VEHICLE_OPTIONS_COSTURI_ADITIONALE,
} from "../Utils/Permissions/vehicleCosts";
import {
  DINAMIC_TABS_ACCES_LOGS,
  MAIN_SLIDER_ACCES_LOGS,
  MAIN_TABLE_ACCES_LOGS,
  ROUTER_ACCES_LOGS,
  VEHICLE_OPTIONS_ACCES_LOGS,
} from "../Utils/Permissions/logs";
import {
  DINAMIC_TABS_MANAGE_UTILIZATORI,
  MAIN_SLIDER_MANAGE_UTILIZATORI,
  MAIN_TABLE_MANAGE_UTILIZATORI,
  ROUTER_MANAGE_UTILIZATORI,
  VEHICLE_OPTIONS_MANAGE_UTILIZATORI,
} from "../Utils/Permissions/users ";
import {
  DINAMIC_TABS_VIZUALIZARE_STATISTICI,
  MAIN_SLIDER_VIZUALIZARE_STATISTICI,
  MAIN_TABLE_VIZUALIZARE_STATISTICI,
  ROUTER_VIZUALIZARE_STATISTICI,
  VEHICLE_OPTIONS_VIZUALIZARE_STATISTICI,
} from "../Utils/Permissions/reports ";
import {
  DINAMIC_TABS_MANAGE_TASKURI,
  MAIN_SLIDER_MANAGE_TASKURI,
  MAIN_TABLE_MANAGE_TASKURI,
  ROUTER_MANAGE_TASKURI,
  TASK_FORM_ASSIGN_TASKS,
  VEHICLE_OPTIONS_MANAGE_TASKURI,
} from "../Utils/Permissions/manage-taskuri";
import {
  DINAMIC_TABS_MANAGE_CALENDAR,
  MAIN_SLIDER_MANAGE_CALENDAR,
  MAIN_TABLE_MANAGE_CALENDAR,
  ROUTER_MANAGE_CALENDAR,
  VEHICLE_OPTIONS_MANAGE_CALENDAR,
} from "../Utils/Permissions/manage-calendar";
import {
  DINAMIC_TABS_MANAGE_COSTURI_ADMINISTRATIVE,
  MAIN_SLIDER_MANAGE_COSTURI_ADMINISTRATIVE,
  MAIN_TABLE_MANAGE_COSTURI_ADMINISTRATIVE,
  ROUTER_MANAGE_COSTURI_ADMINISTRATIVE,
  VEHICLE_OPTIONS_MANAGE_COSTURI_ADMINISTRATIVE,
} from "../Utils/Permissions/costs ";
import {
  DINAMIC_TABS_PLATFORM_SETTINGS,
  MAIN_SLIDER_PLATFORM_SETTINGS,
  MAIN_TABLE_PLATFORM_SETTINGS,
  ROUTER_PLATFORM_SETTINGS,
  VEHICLE_OPTIONS_PLATFORM_SETTINGS,
} from "../Utils/Permissions/platformSettings";
import {
  DINAMIC_TABS_RESURSE,
  MAIN_SLIDER_RESURSE,
  MAIN_TABLE_RESURSE,
  ROUTER_RESURSE,
  VEHICLE_OPTIONS_RESURSE,
} from "../Utils/Permissions/clients";
import {
  DASHBOARD_FINANCIAL_DEPARTMENT,
  DINAMIC_TABS_DASHBOARD,
  LOGIN_PAGE_DASHBOARD,
  MAIN_SLIDER_DASHBOARD,
  MAIN_TABLE_DASHBOARD,
  ROUTER_DASHBOARD,
  VEHICLE_MAIN_INFO_DASHBOARD,
  VEHICLE_OPTIONS_DASHBOARD,
} from "../Utils/Permissions/vehiclesDashboard";
import {
  DINAMIC_TABS_DOCUMENTE_FINANCIARE,
  MAIN_SLIDER_DOCUMENTE,
  MAIN_TABLE_DOCUMENTE_FINANCIARE,
  ROUTER_DOCUMENTE_FINANCIARE,
  VEHICLE_MAIN_INFO,
  VEHICLE_OPTIONS_DOCUMENTE_FINANCIARE,
} from "../Utils/Permissions/vehicleDocuments";
import {
  DINAMIC_TABS_ATRIBUIE_COMANDA_MASINA,
  MAIN_TABLE_ATRIBUIE_COMANDA_MASINA,
  ROUTER_ATRIBUIE_COMANDA_MASINA,
  VEHICLE_OPTIONS_ATRIBUIE_COMANDA_MASINA,
} from "../Utils/Permissions/atribuie-comanda-masina";
import {
  DINAMIC_TABS_VEHICULE_GESTIONARE,
  MAIN_TABLE_VEHICULE_GESTIONARE,
  ROUTER_VEHICULE_GESTIONARE,
  VEHICLE_OPTIONS_VEHICULE_GESTIONARE,
} from "../Utils/Permissions/vehicleDetails";
import {
  DINAMIC_TABS_EDITEAZA_SERVICII,
  DINAMIC_TABS_EDITEAZA_VEHICULE,
  MAIN_TABLE_EDITEAZA_VEHICULE,
  ROUTER_EDITEAZA_VEHICULE,
  VEHICLE_OPTIONS_EDITEAZA_VEHICULE,
} from "../Utils/Permissions/deleteVehicles ";
import {
  DINAMIC_TABS_ADD_VEHICLE,
  MAIN_TABLE_ADD_VEHICLE,
  ROUTER_ADD_VEHICLE,
  VEHICLE_MAIN_INFO_EDIT_VEHICLE,
  VEHICLE_OPTIONS_ADD_VEHICLE,
} from "../Utils/Permissions/editVehicles";
import { VEHICLE_MAIN_INFO_VEHICLES_RESOURCES } from "../Utils/Permissions/gestionare-firme";
import {
  DINAMIC_TABS_FINANCIAL_DEPARTMENT,
  LOGIN_PAGE_FINANCIAL_DEPARTMENT,
  MAIN_HEADER_FINANCIAL_DEPARTMENT,
  MAIN_SLIDER_FINANCIAL_DEPARTMENT,
  MAIN_TABLE_FINANCIAL_DEPARTMENT,
  ROUTER_FINANCIAL_DEPARTMENT,
  VEHICLES_DASHBOARD_FINANCIAL_DEPARTMENT,
  VEHICLE_FINANCIAL_DEPARTMENT,
} from "../Utils/Permissions/financialDepartment";
import {
  DINAMIC_TABS_SALES_DEPARTMENT,
  MAIN_HEADER_SALES,
  MAIN_SLIDER_SALES_DEPARTMENT,
  MAIN_TABLE_SALES_DEPARTMENT,
  ROUTER_SALES_DEPARTMENT,
  VEHICLES_SALES_DEPARTMENT,
  VEHICLE_OPTIONS_SALES_DEPARTMENT,
} from "../Utils/Permissions/sales";
import {
  DINAMIC_TABS_ACQUISITIONS_DEPARTMENT,
  LOGIN_PAGE_ACQUISITIONS_DEPARTMENT,
  MAIN_HEADER_ACQUISITIONS_DEPARTMENT,
  MAIN_SLIDER_ACQUISITIONS_DEPARTMENT,
  ROUTER_ACQUISITIONS_DEPARTMENT,
  VEHICLES_ACQUISITIONS_DEPARTMENT,
  VEHICLE_ACQUISITIONS_DEPARTMENT,
} from "../Utils/Permissions/acquisitions";
import {
  DINAMIC_TABS_LOGISTICS_DEPARTMENT,
  MAIN_HEADER_LOGISTICS_DEPARTMENT,
  MAIN_SLIDER_LOGISTICS_DEPARTMENT,
  MAIN_TABLE_LOGISTICS_DEPARTMENT,
  ROUTER_LOGISTICS_DEPARTMENT,
  VEHICLE_LOGISTICS_DEPARTMENT,
} from "../Utils/Permissions/logistics";
import {
  DINAMIC_TABS_GARANTII,
  ROUTER_GARANTII,
  VEHICLE_OPTIONS_GARANTII,
} from "../Utils/Permissions/manage-raportari";
import {
  DINAMIC_TABS_ACCES_TEMPLATES,
  MAIN_SLIDER_ACCES_TEMPLATES,
  MAIN_TABLE_ACCES_TEMPLATES,
  ROUTER_ACCES_TEMPLATES,
  VEHICLE_OPTIONS_ACCES_TEMPLATES,
} from "../Utils/Permissions/templates";
import {
  DINAMIC_TABS_CLIENT_MESSAGES,
  MAIN_SLIDER_CLIENT_MESSAGES,
  MAIN_TABLE_CLIENT_MESSAGES,
  ROUTER_CLIENT_MESSAGES,
  VEHICLES_CLIENT_MESSAGES,
  VEHICLE_CLIENT_MESSAGES,
} from "../Utils/Permissions/clientsMessages";
import {
  DINAMIC_TABS_PHOTOS,
  MAIN_TABLE_PHOTOS,
  ROUTER_PHOTOS,
  VEHICLE_OPTIONS_PHOTOS,
} from "../Utils/Permissions/vehiclePhotos";
import {
  DINAMIC_TABS_EDIT_STATUS,
  MAIN_TABLE_EDIT_STATUS,
  ROUTER_EDIT_STATUS,
  VEHICLES_DASHBOARD_EDIT_STATUS,
  VEHICLE_OPTIONS_EDIT_STATUS,
} from "../Utils/Permissions/editStatus";
import {
  MAIN_SLIDER_ANAF_DEPARTMENT,
  ROUTER_ANAF_DEPARTMENT,
} from "../Utils/Permissions/anafNotifications";
import {
  DINAMIC_TABS_HOMEPAGE,
  MAIN_SLIDER_HOMEPAGE,
  MAIN_TABLE_HOMEPAGE,
  ROUTER_HOMEPAGE,
  VEHICLE_OPTIONS_HOMEPAGE,
} from "../Utils/Permissions/homePage";
import {
  DINAMIC_TABS_SALARY,
  MAIN_SLIDER_SALARY,
  MAIN_TABLE_SALARY,
  ROUTER_SALARY,
  SALARY_COMPONENT,
  VEHICLE_OPTIONS_SALARY,
} from "../Utils/Permissions/usersSalary";
import {
  CLIENT_MESSAGES_FOR_ALL_MESSAGES,
  DASHBOARD_ACCES_FOR_ALL_MESSAGES,
  DINAMIC_TABS_ACCES_FOR_ALL_MESSAGES,
  MAIN_SLIDER_ACCES_FOR_ALL_MESSAGES,
  MAIN_TABLE_ACCES_FOR_ALL_MESSAGES,
  ROUTER_ACCES_FOR_ALL_MESSAGES,
  VEHICLE_ACCES_FOR_ALL_MESSAGES,
  VEHICLES_ACCES_FOR_ALL_MESSAGES,
} from "../Utils/Permissions/accesForAllMessages";
import {
  DINAMIC_TABS_VIN_REQUESTS,
  MAIN_SLIDER_VIN_REQUESTS,
  MAIN_TABLE_VIN_REQUESTS,
  ROUTER_VIN_REQUESTS,
  VEHICLE_VIN_REQUESTS,
} from "../Utils/Permissions/VINRequest";
import {
  ROUTER_INFO_SELL_BONUS,
  VEHICLE_MAIN_INFO_SELL_BONUS,
} from "../Utils/Permissions/sellBonus";
// import {
//   DINAMIC_TABS_MARKETING_DEPARTMENT,
//   LOGIN_PAGE_MARKETING_DEPARTMENT,
//   MAIN_HEADER_MARKETING_DEPARTMENT,
//   MAIN_SLIDER_MARKETING_DEPARTMENT,
//   ROUTER_MARKETING_DEPARTMENT,
//   VEHICLES_MARKETING_DEPARTMENT,
//   VEHICLE_MARKETING_DEPARTMENT,
// } from "../Utils/Permissions/marketing";
import { VEHICLE_OPTIONS_DUPLICATE_VEHICLE } from "../Utils/Permissions/duplicateVehicle";
import { VEHICLE_OPTIONS_EDIT_SOLD_VEHICLE } from "../Utils/Permissions/editSoldVehicle";
import { GENERATE_VEHICLE_AD } from "../Utils/Permissions/generateVehicleAd";
import {
  DINAMIC_TABS_DEACTIVATE_INTERMEDIATED_VEHICLE,
  MAIN_TABLE_DEACTIVATE_INTERMEDIATED_VEHICLE,
  ROUTER_DEACTIVATE_INTERMEDIATED_VEHICLE,
} from "../Utils/Permissions/deactivateIntermediatedVehicle";
import {
  MAIN_SLIDER_VIEW_XAUTO_VEHICLES,
  ROUTER_VIEW_XAUTO_VEHICLES_REQUESTS,
} from "../Utils/Permissions/viewXautoVehicles";
import {
  DINAMIC_TABS_APPLICATIONS,
  MAIN_SLIDER_APPLICATIONS,
  MAIN_TABLE_APPLICATIONS,
  ROUTER_APPLICATIONS,
  VEHICLE_OPTIONS_APPLICATIONS,
} from "../Utils/Permissions/applications";

//NAMES FOR EACH COMPONENT
export const componentNames = {
  LocalRouter: "LocalRouter",
  DinamicTabs: "DinamicTabs",
  VehicleOptions: "VehicleOptions",
  DinamicTabsServices: "DinamicTabsServices",
  MainTable: "MainTable",
  MainHeader: "MainHeader",
  VehicleMainInfo: "VehicleMainInfo",
  MainSlider: "MainSlider",
  VehiclesDashboard: "VehiclesDashboard",
  LoginPage: "LoginPage",
  DashboardClientMessages: "DashboardClientMessages",
  ClientMessages: "ClientMessages",
  SalaryComponent: "SalaryComponent",
  MainDashboard: "MainDashboard",
  Dashboard: "Dashboard",
  TaskForm: "TaskForm",
  TasksBacklog: "TasksBacklog",
};

//ADD BUTTON PERMISSION

//TABLE OPTIONS

export const PermissionsUI: { [key: string]: any } = {
  homepage: {
    LocalRouter: ROUTER_HOMEPAGE,
    MainSlider: {
      info: MAIN_SLIDER_HOMEPAGE,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_HOMEPAGE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_HOMEPAGE,
    },
    MainTable: {
      info: MAIN_TABLE_HOMEPAGE,
    },
  },
  vehiclesDashboard: {
    LocalRouter: ROUTER_DASHBOARD,
    MainSlider: {
      info: MAIN_SLIDER_DASHBOARD,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_DASHBOARD,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_DASHBOARD,
    },
    MainTable: {
      info: MAIN_TABLE_DASHBOARD,
    },
    VehiclesDashboard: {
      info: DASHBOARD_FINANCIAL_DEPARTMENT,
    },
    LoginPage: {
      info: LOGIN_PAGE_DASHBOARD,
    },

    VehicleMainInfo: {
      info: VEHICLE_MAIN_INFO_DASHBOARD,
    },
  },
  vehicleDetailings: {
    LocalRouter: ROUTER_INTERVENTII_DETAILING,

    VehicleOptions: {
      info: VEHICLE_OPTIONS_INTERVENTII_DETAILING,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_INTERVENTII_DETAILING,
    },
    VehicleDashboardTable: {
      permission: VEHICLE_TABLE_INTERVENTII_DETAILING,
    },
  },
  vehicleServices: {
    LocalRouter: ROUTER_INTERVENTII_SERVICE,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_INTERVENTII_SERVICE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_INTERVENTII_SERVICE,
    },
  },
  vehiclePaintings: {
    LocalRouter: ROUTER_INTERVENTII_VOPSITORIE,

    VehicleOptions: {
      info: VEHICLE_OPTIONS_INTERVENTII_VOPSITORIE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_INTERVENTII_VOPSITORIE,
    },
  },
  vehicleCosts: {
    LocalRouter: ROUTER_COSTURI_ADITIONALE,

    VehicleOptions: {
      info: VEHICLE_OPTIONS_COSTURI_ADITIONALE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_COSTURI_ADITIONALE,
    },
    MainTable: {
      info: MAIN_TABLE_COSTURI_ADITIONALE,
    },
  },
  logs: {
    LocalRouter: ROUTER_ACCES_LOGS,
    MainSlider: {
      info: MAIN_SLIDER_ACCES_LOGS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_ACCES_LOGS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ACCES_LOGS,
    },
    MainTable: {
      info: MAIN_TABLE_ACCES_LOGS,
    },
  },
  users: {
    LocalRouter: ROUTER_MANAGE_UTILIZATORI,
    MainSlider: {
      info: MAIN_SLIDER_MANAGE_UTILIZATORI,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_MANAGE_UTILIZATORI,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_MANAGE_UTILIZATORI,
    },
    MainTable: {
      info: MAIN_TABLE_MANAGE_UTILIZATORI,
    },
  },
  reports: {
    LocalRouter: ROUTER_VIZUALIZARE_STATISTICI,
    MainSlider: {
      info: MAIN_SLIDER_VIZUALIZARE_STATISTICI,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_VIZUALIZARE_STATISTICI,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_VIZUALIZARE_STATISTICI,
    },
    MainTable: {
      info: MAIN_TABLE_VIZUALIZARE_STATISTICI,
    },
  },
  tasks: {
    LocalRouter: ROUTER_MANAGE_TASKURI,
    MainSlider: {
      info: MAIN_SLIDER_MANAGE_TASKURI,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_MANAGE_TASKURI,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_MANAGE_TASKURI,
    },
    MainTable: {
      info: MAIN_TABLE_MANAGE_TASKURI,
    },
  },
  assignTasks: {
    TaskForm: TASK_FORM_ASSIGN_TASKS,
    TasksBacklog: TASK_FORM_ASSIGN_TASKS,
  },
  calendar: {
    LocalRouter: ROUTER_MANAGE_CALENDAR,
    MainSlider: {
      info: MAIN_SLIDER_MANAGE_CALENDAR,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_MANAGE_CALENDAR,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_MANAGE_CALENDAR,
    },
    MainTable: {
      info: MAIN_TABLE_MANAGE_CALENDAR,
    },
  },
  costs: {
    LocalRouter: ROUTER_MANAGE_COSTURI_ADMINISTRATIVE,
    MainSlider: {
      info: MAIN_SLIDER_MANAGE_COSTURI_ADMINISTRATIVE,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_MANAGE_COSTURI_ADMINISTRATIVE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_MANAGE_COSTURI_ADMINISTRATIVE,
    },
    MainTable: {
      info: MAIN_TABLE_MANAGE_COSTURI_ADMINISTRATIVE,
    },
  },
  usersSalary: {
    LocalRouter: ROUTER_SALARY,
    MainSlider: {
      info: MAIN_SLIDER_SALARY,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_SALARY,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_SALARY,
    },
    MainTable: {
      info: MAIN_TABLE_SALARY,
    },
    SalaryComponent: {
      info: SALARY_COMPONENT,
    },
  },
  // TOATE SETARILE VIN ACUM DIN PLATFOMR SETTINGS PENTRU TOATE PERMISIUNILE DE SETARI! A SE EDITA MAI JOS DACA SE VREA PE FIECARE SETARE IN PARTE

  platformSettings: {
    LocalRouter: ROUTER_PLATFORM_SETTINGS,
    MainSlider: {
      info: MAIN_SLIDER_PLATFORM_SETTINGS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_PLATFORM_SETTINGS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_PLATFORM_SETTINGS,
    },
    MainTable: {
      info: MAIN_TABLE_PLATFORM_SETTINGS,
    },
  },
  statusSettings: {
    LocalRouter: ROUTER_PLATFORM_SETTINGS,
    MainSlider: {
      info: MAIN_SLIDER_PLATFORM_SETTINGS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_PLATFORM_SETTINGS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_PLATFORM_SETTINGS,
    },
    MainTable: {
      info: MAIN_TABLE_PLATFORM_SETTINGS,
    },
  },
  rolesSettings: {
    LocalRouter: ROUTER_PLATFORM_SETTINGS,
    MainSlider: {
      info: MAIN_SLIDER_PLATFORM_SETTINGS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_PLATFORM_SETTINGS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_PLATFORM_SETTINGS,
    },
    MainTable: {
      info: MAIN_TABLE_PLATFORM_SETTINGS,
    },
  },
  permissions: {
    LocalRouter: ROUTER_PLATFORM_SETTINGS,
    MainSlider: {
      info: MAIN_SLIDER_PLATFORM_SETTINGS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_PLATFORM_SETTINGS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_PLATFORM_SETTINGS,
    },
    MainTable: {
      info: MAIN_TABLE_PLATFORM_SETTINGS,
    },
  },
  clients: {
    LocalRouter: ROUTER_RESURSE,
    MainSlider: {
      info: MAIN_SLIDER_RESURSE,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_RESURSE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_RESURSE,
    },
    MainTable: {
      info: MAIN_TABLE_RESURSE,
    },
  },
  vehicleDocuments: {
    LocalRouter: ROUTER_DOCUMENTE_FINANCIARE,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_DOCUMENTE_FINANCIARE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_DOCUMENTE_FINANCIARE,
    },
    MainTable: {
      info: MAIN_TABLE_DOCUMENTE_FINANCIARE,
    },
    VehicleMainInfo: {
      info: VEHICLE_MAIN_INFO,
    },
    MainSlider: {
      info: MAIN_SLIDER_DOCUMENTE,
    },
  },
  vehiclePhotos: {
    LocalRouter: ROUTER_PHOTOS,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_PHOTOS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_PHOTOS,
    },
    MainTable: {
      info: MAIN_TABLE_PHOTOS,
    },
  },
  "atribuie-comanda-masina": {
    LocalRouter: ROUTER_ATRIBUIE_COMANDA_MASINA,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_ATRIBUIE_COMANDA_MASINA,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ATRIBUIE_COMANDA_MASINA,
    },
    MainTable: {
      info: MAIN_TABLE_ATRIBUIE_COMANDA_MASINA,
    },
  },
  vehicleDetails: {
    LocalRouter: ROUTER_VEHICULE_GESTIONARE,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_VEHICULE_GESTIONARE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_VEHICULE_GESTIONARE,
    },
    MainTable: {
      info: MAIN_TABLE_VEHICULE_GESTIONARE,
    },
  },
  deleteVehicles: {
    LocalRouter: ROUTER_EDITEAZA_VEHICULE,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_EDITEAZA_VEHICULE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_EDITEAZA_VEHICULE,
    },
    DinamicTabsServices: {
      info: DINAMIC_TABS_EDITEAZA_SERVICII,
    },
    MainTable: {
      info: MAIN_TABLE_EDITEAZA_VEHICULE,
    },
  },
  editVehicles: {
    LocalRouter: ROUTER_ADD_VEHICLE,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_ADD_VEHICLE,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ADD_VEHICLE,
    },
    MainTable: {
      info: MAIN_TABLE_ADD_VEHICLE,
    },
    VehicleMainInfo: {
      info: VEHICLE_MAIN_INFO_EDIT_VEHICLE,
    },
    MainHeader: {
      addVehicle: true,
    },
  },
  duplicateVehicle: {
    LocalRouter: ROUTER_EDITEAZA_VEHICULE,
    VehiclesDashboard: {
      permission: VEHICLE_OPTIONS_DUPLICATE_VEHICLE,
    },
    VehicleOptions: { permission: VEHICLE_OPTIONS_DUPLICATE_VEHICLE },
    MainTable: { permission: VEHICLE_OPTIONS_DUPLICATE_VEHICLE },
  },
  generateVehicleAd: {
    VehicleMainInfo: {
      info: GENERATE_VEHICLE_AD,
    },
    MainTable: {
      route: "vehicleDetails",
    },
    MainDashboard: {
      route: "vehicleDetails",
    },
    MainHeader: {
      info: "vehicleDetails",
    },
  },
  editSoldVehicle: {
    VehicleMainInfo: { info: VEHICLE_OPTIONS_EDIT_SOLD_VEHICLE },
  },
  editStatus: {
    LocalRouter: ROUTER_EDIT_STATUS,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_EDIT_STATUS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_EDIT_STATUS,
    },
    MainTable: {
      info: MAIN_TABLE_EDIT_STATUS,
    },
    VehiclesDashboard: {
      info: VEHICLES_DASHBOARD_EDIT_STATUS,
    },
  },

  vehicleGuarantees: {
    LocalRouter: ROUTER_GARANTII,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_GARANTII,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_GARANTII,
    },
  },

  "gestionare-firme": {
    VehicleMainInfo: {
      info: VEHICLE_MAIN_INFO_VEHICLES_RESOURCES,
    },
  },
  logistics: {
    LocalRouter: ROUTER_LOGISTICS_DEPARTMENT,
    VehicleOptions: {
      info: VEHICLE_LOGISTICS_DEPARTMENT,
    },
    MainSlider: {
      info: MAIN_SLIDER_LOGISTICS_DEPARTMENT,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_LOGISTICS_DEPARTMENT,
    },
    VehiclesDashboard: {
      info: VEHICLE_LOGISTICS_DEPARTMENT,
    },
    MainTable: {
      info: MAIN_TABLE_LOGISTICS_DEPARTMENT,
    },
    MainHeader: {
      info: MAIN_HEADER_LOGISTICS_DEPARTMENT,
    },
  },
  financialDepartment: {
    LocalRouter: ROUTER_FINANCIAL_DEPARTMENT,
    VehicleOptions: {
      info: VEHICLE_FINANCIAL_DEPARTMENT,
    },
    MainSlider: {
      info: MAIN_SLIDER_FINANCIAL_DEPARTMENT,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_FINANCIAL_DEPARTMENT,
    },
    MainTable: {
      info: MAIN_TABLE_FINANCIAL_DEPARTMENT,
    },
    VehiclesDashboard: {
      info: VEHICLES_DASHBOARD_FINANCIAL_DEPARTMENT,
    },
    LoginPage: {
      info: LOGIN_PAGE_FINANCIAL_DEPARTMENT,
    },
    MainHeader: {
      info: MAIN_HEADER_FINANCIAL_DEPARTMENT,
    },
  },

  clientsMessages: {
    LocalRouter: ROUTER_CLIENT_MESSAGES,
    VehicleOptions: {
      info: VEHICLE_CLIENT_MESSAGES,
    },
    MainSlider: {
      info: MAIN_SLIDER_CLIENT_MESSAGES,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_CLIENT_MESSAGES,
    },
    MainTable: {
      info: MAIN_TABLE_CLIENT_MESSAGES,
    },
    VehiclesDashboard: {
      info: VEHICLES_CLIENT_MESSAGES,
    },
  },

  sales: {
    LocalRouter: ROUTER_SALES_DEPARTMENT,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_SALES_DEPARTMENT,
    },
    MainSlider: {
      info: MAIN_SLIDER_SALES_DEPARTMENT,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_SALES_DEPARTMENT,
    },
    MainTable: {
      info: MAIN_TABLE_SALES_DEPARTMENT,
    },
    VehiclesDashboard: {
      info: VEHICLES_SALES_DEPARTMENT,
    },
    MainHeader: {
      info: MAIN_HEADER_SALES,
    },
  },
  acquisitions: {
    LocalRouter: ROUTER_ACQUISITIONS_DEPARTMENT,
    VehicleOptions: {
      info: VEHICLE_ACQUISITIONS_DEPARTMENT,
    },
    MainSlider: {
      info: MAIN_SLIDER_ACQUISITIONS_DEPARTMENT,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ACQUISITIONS_DEPARTMENT,
    },
    VehiclesDashboard: {
      info: VEHICLES_ACQUISITIONS_DEPARTMENT,
    },
    LoginPage: {
      info: LOGIN_PAGE_ACQUISITIONS_DEPARTMENT,
    },
    MainHeader: {
      info: MAIN_HEADER_ACQUISITIONS_DEPARTMENT,
    },
  },
  // marketing: {
  //   LocalRouter: ROUTER_MARKETING_DEPARTMENT,
  //   VehicleOptions: {
  //     info: VEHICLE_MARKETING_DEPARTMENT,
  //   },
  //   MainSlider: {
  //     info: MAIN_SLIDER_MARKETING_DEPARTMENT,
  //   },
  //   DinamicTabs: {
  //     info: DINAMIC_TABS_MARKETING_DEPARTMENT,
  //   },
  //   VehiclesDashboard: {
  //     info: VEHICLES_MARKETING_DEPARTMENT,
  //   },
  //   LoginPage: {
  //     info: LOGIN_PAGE_MARKETING_DEPARTMENT,
  //   },
  //   MainHeader: {
  //     info: MAIN_HEADER_MARKETING_DEPARTMENT,
  //   },
  // },
  anaf: {
    LocalRouter: ROUTER_ANAF_DEPARTMENT,
    MainSlider: {
      info: MAIN_SLIDER_ANAF_DEPARTMENT,
    },
  },
  accesForAllMessages: {
    LocalRouter: ROUTER_ACCES_FOR_ALL_MESSAGES,
    VehicleOptions: {
      info: VEHICLE_ACCES_FOR_ALL_MESSAGES,
    },
    MainSlider: {
      info: MAIN_SLIDER_ACCES_FOR_ALL_MESSAGES,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ACCES_FOR_ALL_MESSAGES,
    },
    MainTable: {
      info: MAIN_TABLE_ACCES_FOR_ALL_MESSAGES,
    },
    VehiclesDashboard: {
      info: VEHICLES_ACCES_FOR_ALL_MESSAGES,
    },
    DashboardClientMessages: {
      info: DASHBOARD_ACCES_FOR_ALL_MESSAGES,
    },
    ClientMessages: {
      accesForAllMessages: CLIENT_MESSAGES_FOR_ALL_MESSAGES,
    },
  },

  VINRequests: {
    LocalRouter: ROUTER_VIN_REQUESTS,
    MainSlider: {
      info: MAIN_SLIDER_VIN_REQUESTS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_VIN_REQUESTS,
    },
    MainTable: {
      info: MAIN_TABLE_VIN_REQUESTS,
    },
    VehicleOptions: {
      info: VEHICLE_VIN_REQUESTS,
    },
    DashboardWidgets: {
      showVinRequestsWidget: true,
    },
  },

  sellBonus: {
    LocalRouter: ROUTER_INFO_SELL_BONUS,
    VehicleMainInfo: {
      info: VEHICLE_MAIN_INFO_SELL_BONUS,
    },
  },

  // PERMISIUNE ASTA ESTE PENTRU ACCESUL LA TEMPLATES//
  // IN MOMENTUL DE FATA NU ERA O PERMISIUNE PENTRU TEMPLATES//
  // AM FOLOSIT UNA EXISTENTA PENTRU A NU CREA O NOUA PERMISIUNE DEOARECE ORICUM TREBUIE SCHIMBATE//
  // NUMELE PERMISIUNII NU ARE NICIO LEGATURA CU CE TREBUIE SA FACA//

  templates: {
    LocalRouter: ROUTER_ACCES_TEMPLATES,
    VehicleOptions: {
      info: VEHICLE_OPTIONS_ACCES_TEMPLATES,
    },
    MainSlider: {
      info: MAIN_SLIDER_ACCES_TEMPLATES,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_ACCES_TEMPLATES,
    },
    MainTable: {
      info: MAIN_TABLE_ACCES_TEMPLATES,
    },
  },

  deactivateIntermediatedVehicle: {
    LocalRouter: ROUTER_DEACTIVATE_INTERMEDIATED_VEHICLE,
    DinamicTabs: {
      info: DINAMIC_TABS_DEACTIVATE_INTERMEDIATED_VEHICLE,
    },
    MainTable: {
      info: MAIN_TABLE_DEACTIVATE_INTERMEDIATED_VEHICLE,
    },
  },
  viewXautoVehicles: {
    LocalRouter: ROUTER_VIEW_XAUTO_VEHICLES_REQUESTS,
    MainSlider: { info: MAIN_SLIDER_VIEW_XAUTO_VEHICLES },
  },
  createNewApplication: {
    LocalRouter: ROUTER_APPLICATIONS,
    MainSlider: {
      info: MAIN_SLIDER_APPLICATIONS,
    },
    VehicleOptions: {
      info: VEHICLE_OPTIONS_APPLICATIONS,
    },
    DinamicTabs: {
      info: DINAMIC_TABS_APPLICATIONS,
    },
    MainTable: {
      info: MAIN_TABLE_APPLICATIONS,
    },
  },
};

export const RolesEnum = {
  admin: "Administrator",
  saleDepartment: "Sef departament vanzari",
  financialDepartment: "Sef departament financiar",
  logisticsDepartment: "Sef departament logistica",
  acquisitionsDepartment: "Sef departament achizitii",
};
export const FIRST_SEEN_USER_ID_NOT_ALLOCATED = '{"first_seen_user_id":null}';
